import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Slide from './slide';
import SignUp from './signup';
import Comment from './comment';
import Share from './share';
import { getClient } from '@src/utils/index';
import useToast from '@src/hook/useToast';
import Toast from '@src/components/toast';
import RuleBtn from './rule';
import Ad from './ad';
import Prize from './prize';
import useLogin from '@src/hook/useLogin';
import useSina from '@src/hook/useSina';
import { add } from '@src/services/api';
import { pageHandler } from '@src/utils';

pageHandler({});
const Layout = ({ content }) => {
    const { pageData, bannerData, prizeData = {} } = content;
    const { show, setShow, setToastContent, toastContent } = useToast();
    const { sinaInit } = useSina();
    const { gotoLogin } = useLogin();
    const init = async () => {
        const clientType = getClient();

        if (clientType === 'weibo') {
            await sinaInit();
        }
        await gotoLogin({ sinaLogin: false });
    };

    useEffect(() => {
        init();
    }, []);

    return (
        <div className={styles.layout}>
            <div className={styles.header}>
                <div className={styles.topfaqi}>发起方：</div>
                <div className={styles.toplianhefaqi}>联合发起方：</div>
            </div>
            <Slide content={content} />
            <Prize content={prizeData} />
            <Ad content={bannerData} />
            <div className={styles.expert} />
            <SignUp />
            <Comment content={content} setShow={setShow} setToastContent={setToastContent} />
            <div className={styles.footer} />
            <Share content={content} setToastContent={setToastContent} setToastShow={setShow} />
            {show ? <Toast content={toastContent} /> : null}
            <RuleBtn />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
